import { __decorate, __metadata } from 'tslib';
import { isDevMode, TemplateRef, ViewContainerRef, Input, Directive, Component, NgModule, ɵɵdefineInjectable, Injectable } from '@angular/core';
import { isOn, set } from 'feature-toggle-service';
import { CommonModule } from '@angular/common';

var FeatureToggleDirective = /** @class */ (function () {
    function FeatureToggleDirective(templateRef, viewContainer) {
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
        this.isOn = false;
    }
    FeatureToggleDirective.prototype.ngOnInit = function () {
        if (!this.featureToggle) {
            throw new Error('Attribute `featureToggle` should not be null or empty');
        }
        this.shouldRender();
    };
    FeatureToggleDirective.prototype.ngDoCheck = function () {
        if (this.isOn !== this.isOnCheck(this.featureToggle)) {
            this.shouldRender();
        }
    };
    FeatureToggleDirective.prototype.shouldRender = function () {
        this.isOn = this.isOnCheck(this.featureToggle);
        if (this.isOn) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        }
        else {
            this.viewContainer.clear();
        }
    };
    FeatureToggleDirective.prototype.isOnCheck = function (featureToggle) {
        var DEV_MODE = isDevMode();
        var isFeatureToggleOn = function (toggle) {
            return toggle[0] === '!' ? !isOn(toggle.replace('!', '')) : isOn(toggle);
        };
        if (typeof featureToggle === 'string') {
            return isFeatureToggleOn(featureToggle);
        }
        else if (Array.isArray(featureToggle)) {
            return featureToggle.every(isFeatureToggleOn);
        }
        else if (DEV_MODE) {
            console.error('`NgxFeatureToggle`: `featureToggle` should receive an array or an string as a value.');
        }
    };
    FeatureToggleDirective.ctorParameters = function () { return [
        { type: TemplateRef },
        { type: ViewContainerRef }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], FeatureToggleDirective.prototype, "featureToggle", void 0);
    FeatureToggleDirective = __decorate([
        Directive({
            // tslint:disable-next-line: directive-selector
            selector: '[featureToggle]',
        }),
        __metadata("design:paramtypes", [TemplateRef,
            ViewContainerRef])
    ], FeatureToggleDirective);
    return FeatureToggleDirective;
}());

var FeatureToggleProviderComponent = /** @class */ (function () {
    function FeatureToggleProviderComponent() {
        this.features = {};
        this.currentConfig = {};
    }
    FeatureToggleProviderComponent.prototype.ngOnInit = function () {
        if (typeof this.features !== 'object') {
            throw new Error('Attribute `features` should not be null or empty');
        }
        this.setFeatureToggles();
    };
    FeatureToggleProviderComponent.prototype.ngDoCheck = function () {
        this.setFeatureToggles();
    };
    FeatureToggleProviderComponent.prototype.setFeatureToggles = function () {
        if (this.currentConfig !== this.features) {
            // Using `Object.assign()` method for bundle size decreasing purposes
            // It's required since it needs a new memory reference
            // for the new object value
            this.currentConfig = Object.assign({}, this.features);
            set(this.features);
        }
    };
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], FeatureToggleProviderComponent.prototype, "features", void 0);
    FeatureToggleProviderComponent = __decorate([
        Component({
            selector: 'feature-toggle-provider',
            template: '<ng-content></ng-content>'
        })
    ], FeatureToggleProviderComponent);
    return FeatureToggleProviderComponent;
}());

var FeatureToggleModule = /** @class */ (function () {
    function FeatureToggleModule() {
    }
    FeatureToggleModule = __decorate([
        NgModule({
            declarations: [FeatureToggleProviderComponent, FeatureToggleDirective],
            exports: [FeatureToggleProviderComponent, FeatureToggleDirective],
            imports: [CommonModule],
        })
    ], FeatureToggleModule);
    return FeatureToggleModule;
}());

var NgxFeatureToggleCanActivateGuard = /** @class */ (function () {
    function NgxFeatureToggleCanActivateGuard() {
    }
    NgxFeatureToggleCanActivateGuard.prototype.isDevMode = function () {
        return isDevMode();
    };
    NgxFeatureToggleCanActivateGuard.prototype.canActivate = function (route) {
        var DEV_MODE = this.isDevMode();
        if (!route || !route.data || !route.data.featureToggle) {
            if (DEV_MODE) {
                console.error('`NgxFeatureToggleCanActivateGuard` need to receive `featureToggle` as data in your route configuration.');
            }
            return false;
        }
        var isFeatureToggleOn = function (toggle) {
            return toggle[0] === '!' ? !isOn(toggle.replace('!', '')) : isOn(toggle);
        };
        if (typeof route.data.featureToggle === 'string') {
            return isFeatureToggleOn(route.data.featureToggle);
        }
        else if (Array.isArray(route.data.featureToggle)) {
            return route.data.featureToggle.every(isFeatureToggleOn);
        }
        if (DEV_MODE) {
            console.error('`NgxFeatureToggleCanActivateGuard` need to receive `featureToggle` as data as an array or string in your route configuration.');
        }
        return false;
    };
    NgxFeatureToggleCanActivateGuard.ɵprov = ɵɵdefineInjectable({ factory: function NgxFeatureToggleCanActivateGuard_Factory() { return new NgxFeatureToggleCanActivateGuard(); }, token: NgxFeatureToggleCanActivateGuard, providedIn: "root" });
    NgxFeatureToggleCanActivateGuard = __decorate([
        Injectable({ providedIn: 'root' })
    ], NgxFeatureToggleCanActivateGuard);
    return NgxFeatureToggleCanActivateGuard;
}());

var NgxFeatureToggleCanActivateChildGuard = /** @class */ (function () {
    function NgxFeatureToggleCanActivateChildGuard() {
    }
    NgxFeatureToggleCanActivateChildGuard.prototype.isDevMode = function () {
        return isDevMode();
    };
    NgxFeatureToggleCanActivateChildGuard.prototype.canActivateChild = function (route) {
        var DEV_MODE = this.isDevMode();
        if (!route || !route.data || !route.data.featureToggle) {
            if (DEV_MODE) {
                console.error('`NgxFeatureToggleCanActivateChildGuard` need to receive `featureToggle` as data in your route configuration.');
            }
            return false;
        }
        var isFeatureToggleOn = function (toggle) {
            return toggle[0] === '!' ? !isOn(toggle.replace('!', '')) : isOn(toggle);
        };
        if (typeof route.data.featureToggle === 'string') {
            return isFeatureToggleOn(route.data.featureToggle);
        }
        else if (Array.isArray(route.data.featureToggle)) {
            return route.data.featureToggle.every(isFeatureToggleOn);
        }
        if (DEV_MODE) {
            console.error('`NgxFeatureToggleCanActivateChildGuard` need to receive `featureToggle` as data as an array or string in your route configuration.');
        }
        return false;
    };
    NgxFeatureToggleCanActivateChildGuard.ɵprov = ɵɵdefineInjectable({ factory: function NgxFeatureToggleCanActivateChildGuard_Factory() { return new NgxFeatureToggleCanActivateChildGuard(); }, token: NgxFeatureToggleCanActivateChildGuard, providedIn: "root" });
    NgxFeatureToggleCanActivateChildGuard = __decorate([
        Injectable({ providedIn: 'root' })
    ], NgxFeatureToggleCanActivateChildGuard);
    return NgxFeatureToggleCanActivateChildGuard;
}());

var NgxFeatureToggleCanLoadGuard = /** @class */ (function () {
    function NgxFeatureToggleCanLoadGuard() {
    }
    NgxFeatureToggleCanLoadGuard.prototype.isDevMode = function () {
        return isDevMode();
    };
    NgxFeatureToggleCanLoadGuard.prototype.canLoad = function (route) {
        var DEV_MODE = this.isDevMode();
        if (!route || !route.data || !route.data.featureToggle) {
            if (DEV_MODE) {
                console.error('`NgxFeatureToggleCanLoadGuard` need to receive `featureToggle` as data in your route configuration.');
            }
            return false;
        }
        var isFeatureToggleOn = function (toggle) {
            return toggle[0] === '!' ? !isOn(toggle.replace('!', '')) : isOn(toggle);
        };
        if (typeof route.data.featureToggle === 'string') {
            return isFeatureToggleOn(route.data.featureToggle);
        }
        else if (Array.isArray(route.data.featureToggle)) {
            return route.data.featureToggle.every(isFeatureToggleOn);
        }
        if (DEV_MODE) {
            console.error('`NgxFeatureToggleCanLoadGuard` need to receive `featureToggle` as data as an array or string in your route configuration.');
        }
        return false;
    };
    NgxFeatureToggleCanLoadGuard.ɵprov = ɵɵdefineInjectable({ factory: function NgxFeatureToggleCanLoadGuard_Factory() { return new NgxFeatureToggleCanLoadGuard(); }, token: NgxFeatureToggleCanLoadGuard, providedIn: "root" });
    NgxFeatureToggleCanLoadGuard = __decorate([
        Injectable({ providedIn: 'root' })
    ], NgxFeatureToggleCanLoadGuard);
    return NgxFeatureToggleCanLoadGuard;
}());

/*
 * Public API Surface of ngx-feature-toggle
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FeatureToggleDirective, FeatureToggleModule, FeatureToggleProviderComponent, NgxFeatureToggleCanActivateChildGuard, NgxFeatureToggleCanActivateGuard, NgxFeatureToggleCanLoadGuard };
//# sourceMappingURL=ngx-feature-toggle.js.map
